import { CurrencyService } from "../services/CurrencyService";
import { formatMoney } from "../utils/formatters";

export class BuyAndSell {
  private $wrapper: JQuery<HTMLElement>;
  private static TAB_CONTENT_ACTIVE_CLASS = "buy-and-sell-tab-content-active";
  private static TAB_ACTIVE_CLASS = "buy-and-sell-tab-active";

  constructor() {
    this.$wrapper = $(".buy-and-sell-module-wrapper");

    this.bindEvents();
    this.getData();
  }

  private async getData() {
    const currency = await CurrencyService.getSelected();

    this.setupMasks(currency!!);
  }

  private setupMasks(currency: Currency) {
    if (!currency?.code) {
      return false;
    }
    // this.$wrapper.find("#buy-input").attr("placeholder", `0 ${currency?.code}`);
    this.$wrapper
      .find("#sell-tab-content .buy-and-sell-total-value")
      .html(`0 ${currency.code}`);

    this.$wrapper
      .find("#buy-tab-content .buy-and-sell-total-value")
      .html(`0 ${currency.code}`);

    this.$wrapper.find("#sell-input").maskMoney({
      prefix: "R$ ",
      allowNegative: false,
      thousands: ".",
      decimal: ",",
    });

    this.$wrapper.find("#buy-input").maskMoney({
      prefix: "R$ ",
      allowNegative: false,
      thousands: ".",
      decimal: ",",
    });
  }

  private bindEvents() {
    this.$wrapper
      .find(".buy-and-sell-tab")
      .on("click", this.onTabClick.bind(this));
    this.$wrapper
      .find("#buy-input")
      .on("keyup", this.onBuyInputKeyup.bind(this));
    this.$wrapper
      .find("#sell-input")
      .on("keyup", this.onSellInputKeyup.bind(this));
  }

  private onTabClick(event: JQuery.ClickEvent) {
    const id = $(event.currentTarget).attr("href") as string;

    event.preventDefault();
    this.showTabContent(id);
    this.setTabActive(id);
  }

  private async onBuyInputKeyup(event: JQuery.KeyUpEvent) {
    const currency = await CurrencyService.getSelected();
    const $input = $(event.currentTarget);
    const unmasked = $input.maskMoney("unmasked");
    const value = unmasked[0] as number;

    const result = value / currency?.sellPrice!!;

    this.$wrapper
      .find("#buy-tab-content .buy-and-sell-total-value")
      .html(`${result.toFixed(5)} ${currency?.code}`);
  }

  private async onSellInputKeyup(event: JQuery.KeyUpEvent) {
    const currency = await CurrencyService.getSelected();
    const $input = $(event.currentTarget);
    const unmasked = $input.maskMoney("unmasked");
    const value = unmasked[0] as number;
    const result = value / currency?.sellPrice!!;

    this.$wrapper
      .find("#sell-tab-content .buy-and-sell-total-value")
      .html(`${result.toFixed(5)} ${currency?.code}`);
  }

  private showTabContent(id: string) {
    this.$wrapper
      .find(id)
      .addClass(BuyAndSell.TAB_CONTENT_ACTIVE_CLASS)
      .siblings(`.${BuyAndSell.TAB_CONTENT_ACTIVE_CLASS}`)
      .removeClass(BuyAndSell.TAB_CONTENT_ACTIVE_CLASS);
  }

  private setTabActive(contentId: string) {
    const $tab = this.$wrapper.find(`.buy-and-sell-tab[href=${contentId}]`);

    $tab
      .addClass(BuyAndSell.TAB_ACTIVE_CLASS)
      .siblings(`.${BuyAndSell.TAB_ACTIVE_CLASS}`)
      .removeClass(BuyAndSell.TAB_ACTIVE_CLASS);
  }
}
